/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ROUTES } from 'src/constants/routes';
import { getPurchasePolicyAdditionalData } from '../../redux/selectors/purchasePolicy';
import { useLocationSearch } from './useLocationSearch';
import { useNavigate } from 'react-router-dom';

const useGoToConfirmationPageIfAlreadyPurchased = () => {
  const { purchased } = useSelector(getPurchasePolicyAdditionalData);
  const navigate = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();

  useEffect(() => {
    if (purchased) {
      navigate(getUrlWithQueryParams(ROUTES.ALREADY_PURCHASED_PATH), {
        replace: true,
      });
    }
  }, []);
};

export default useGoToConfirmationPageIfAlreadyPurchased;
